export const API_URL = process.env.VUE_APP_APIURL + '/api';
export const WS_URL = process.env.VUE_APP_APIURL;
